import { useMutation, useQueryClient } from "@tanstack/react-query";
import {
  followUser,
  unfollowUser,
  followShop,
  unfollowShop,
} from "../utility/httpActions/userActions";
import { trackEvent } from "../utility/analytics";

export const useFollowUser = (userId, options = {}) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (isFollowing) =>
      isFollowing ? unfollowUser(userId) : followUser(userId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["publicUser", userId] });
      queryClient.invalidateQueries({ queryKey: ["userFollowers", userId] });
      queryClient.invalidateQueries({ queryKey: ["userFollowing", userId] });
      options.onSuccess?.();
    },
  });
};

export const useFollowShop = (shopId, options = {}) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (isFollowing) =>
      isFollowing ? unfollowShop(shopId) : followShop(shopId),
    onSuccess: (_, isFollowing) => {
      queryClient.invalidateQueries({ queryKey: ["publicShop", shopId] });
      queryClient.invalidateQueries({ queryKey: ["publicShopByHandle"] });
      queryClient.invalidateQueries({ queryKey: ["shopFollowers", shopId] });
      trackEvent(isFollowing ? "shop_unfollowed" : "shop_followed", { shopId });
      options.onSuccess?.();
    },
  });
};
